import httpClient from "../httpClient";

const LoginService = {
  isCaptchaRequired: function() {
    return httpClient.get("/auth/captcha/required");
  },

  generateCaptcha: function() {
    return httpClient.get("/auth/captcha/generate");
  },

  isAltchaRequired: function() {
    return httpClient.get("/auth/altcha/required");
  },

  generateAltcha: function() {
    return httpClient.get("/auth/altcha/generate");
  },

  validateAltcha: function(request) {
    return httpClient.post("/auth/altcha/validate", request);
  },

  logout: function() {
    return httpClient.post("/auth/logout");
  },
};

export default LoginService;
